import {getDCLProfile} from '../Authentication/utils';
import {auth, db} from '../Firebase/main';


export async function updateAvatar(): Promise<any> {
    const uid = auth.currentUser?.uid;
    if (uid) {
        const profile = await getDCLProfile(uid);
        if (profile) {
            return db.ref(`users/${uid}/avatar`).set(profile.avatar);
        }
    }
}